import axiosInstance from "../../../core/api/interceptors/axiosInterceptor";

// GET: List all credit notes
export const getCreditNotes = async () => {
  const res = await axiosInstance.get("creditnotes/get-credit-notes");
  return res.data;
};

// GET: Get credit note by ID
export const getCreditNote = async (id) => {
  const res = await axiosInstance.get(`creditnotes/get-credit-note/${id}`);
  return res.data;
};

// POST: Add new credit note
export const addCreditNote = async (creditNote) => {
  const res = await axiosInstance.post("creditnotes/add-credit-note", creditNote);
  return res.data;
};

// PUT: Update credit note by ID
export const updateCreditNote = async (id, creditNote) => {
  const res = await axiosInstance.put(`creditnotes/update-credit-note/${id}`, creditNote);
  return res.data;
};

// DELETE: Delete credit note by ID
export const deleteCreditNote = async (id) => {
  const res = await axiosInstance.delete(`creditnotes/delete-credit-note/${id}`);
  return res.data;
};